import React from 'react';
import {Button, Col, Label, Row} from 'reactstrap';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import Translate from "../../shared/language/Translate";
import GeneralUtils from '../../shared/utils/GeneralUtils';
import AvField from "../../shared/component/form/AvField";
import FormSection from "../../shared/component/form/FormSection";
import {toast} from "react-toastify";
import {Password} from 'primereact/password';
import NotificationService from "../../shared/service/NotificationService";
import '../../shared/styles/SettingsPage.css';

const defaultMailSettings = {
    id: null,
    to: null,
    from: null,
    host: null,
    port: null,
    userName: null,
    password: null,
    merchantBranchId:-1
};
export default class MailSettingsSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mailSettings: defaultMailSettings, mailSettingsSaveButtonRender: true,
            mailSettingsTemp:defaultMailSettings,
        }
        this.notificationService = new NotificationService();
    }

    componentDidMount() {
        let id = -1;
        if(this.props.id && this.props.id != null){
           id =  this.props.id;
           defaultMailSettings.merchantBranchId = id;
        }

        this.notificationService.findById(id).then(response => {
            this.setState({
                mailSettings: response, mailSettingsSaveButtonRender: false,
                mailSettingsTemp: Object.assign({}, response)
            });
        });
    }

    render() {
        const embedded = this.props.id != null && this.props.id !== undefined;

        if (embedded) {
            return (
                <div className="settings-page settings-page--embedded">
                    <AvForm>{this.mailSettingsDetails()}</AvForm>
                </div>
            );
        }

        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm>
                    <div className="settings-page__shell">
                        <div className="settings-page__header">
                            <h1 className="settings-page__title">Mail Settings</h1>
                        </div>
                        <div className="settings-page__panel">
                            {this.mailSettingsDetails()}
                        </div>
                    </div>
                </AvForm>
            </div>
        );
    }

    mailSettingsDetails() {

        return (
            <FormSection>
                <div className="settings-page__filter-row settings-page__filter-row--cols-5 settings-page__mail-fields">
                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="mail-from">
                                <Translate contentKey="adminUser.companyNo">From</Translate>
                                <span style={{color: 'red'}}> (*)</span>
                            </Label>
                            <AvField
                                id="mail-from"
                                className="form-control"
                                disabled={!this.state.mailSettingsSaveButtonRender}
                                type="email"
                                name="from"
                                value={this.state.mailSettings.from}
                                onChange={this.__handleChange}/>
                        </AvGroup>
                    </div>
                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="mail-host">
                                <Translate contentKey="adminUser.firstName">Host</Translate>
                                <span style={{color: 'red'}}> (*)</span>
                            </Label>
                            <AvField
                                id="mail-host"
                                type="text"
                                className="form-control"
                                name="host"
                                disabled={!this.state.mailSettingsSaveButtonRender}
                                validate={{
                                    maxLength: {
                                        value: 255,
                                        errorMessage: "You can enter up to 255 characters in this field."
                                    }
                                }}
                                value={this.state.mailSettings.host}
                                onChange={this.__handleChange}/>
                        </AvGroup>
                    </div>
                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="mail-port">
                                <Translate contentKey="adminUser.lastName">Port</Translate>
                                <span style={{color: 'red'}}> (*)</span>
                            </Label>
                            <AvField
                                id="mail-port"
                                type="number"
                                className="form-control"
                                name="port"
                                disabled={!this.state.mailSettingsSaveButtonRender}
                                value={this.state.mailSettings.port}
                                onChange={this.__handleChange}/>
                        </AvGroup>
                    </div>
                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="mail-user">
                                <Translate contentKey="adminUser.emailAddress">User Name</Translate>
                                <span style={{color: 'red'}}> (*)</span>
                            </Label>
                            <AvField
                                id="mail-user"
                                type="text"
                                className="form-control"
                                name="userName"
                                disabled={!this.state.mailSettingsSaveButtonRender}
                                validate={{
                                    maxLength: {
                                        value: 255,
                                        errorMessage: "You can enter up to 255 characters in this field."
                                    }
                                }}
                                value={this.state.mailSettings.userName}
                                onChange={this.__handleChange}/>
                        </AvGroup>
                    </div>
                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="mail-password">
                                <Translate contentKey="adminUser.lastName">Password</Translate>
                                <span style={{color: 'red'}}> (*)</span>
                            </Label>
                            <Password
                                id="mail-password"
                                value={this.state.mailSettings.password}
                                name="password"
                                feedback={false}
                                className="form-control"
                                disabled={!this.state.mailSettingsSaveButtonRender}
                                onChange={this.__handleChange}
                            />
                        </AvGroup>
                    </div>
                </div>

                <div className="settings-page__actions">
                {this.state.mailSettingsSaveButtonRender == false && <Button color="outline-primary" className="settings-page__btn--edit" onClick={() => {
                    this.setState({mailSettingsSaveButtonRender: true});
                }}>
                    <Translate contentKey="entity.action.add">Edit</Translate>
                </Button>}

                {this.state.mailSettingsSaveButtonRender && <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                    this.saveMailSettings();
                }}>
                    <Translate contentKey="entity.action.add">Save</Translate>
                </Button>}

                {this.state.mailSettingsSaveButtonRender &&
                    <Button color="outline-primary" className="settings-page__btn--cancel" onClick={() => {
                        let obj1 = this.state.mailSettingsTemp;
                        this.setState({
                            mailSettings: Object.assign({}, obj1), mailSettingsSaveButtonRender: false
                        });
                    }}>
                        <Translate contentKey="entity.action.cancel">Cancel</Translate>
                    </Button>}
                </div>
            </FormSection>
        );
    };


    saveMailSettings = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.mailSettings.from) ||
            GeneralUtils.isNullOrEmpty(this.state.mailSettings.host) ||
            GeneralUtils.isNullOrEmpty(this.state.mailSettings.port) ||
            GeneralUtils.isNullOrEmpty(this.state.mailSettings.merchantBranchId) ||
            GeneralUtils.isNullOrEmpty(this.state.mailSettings.userName) ||
            GeneralUtils.isNullOrEmpty(this.state.mailSettings.password)
        ) {
            return toast.warn("Please fill the required fields!");
        } else {
            if (!GeneralUtils.isNullOrEmpty(this.state.mailSettings.id)) {
                this.notificationService.update(this.state.mailSettings)
                    .then((response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            this.setState({
                                mailSettingsSaveButtonRender: false, mailSettings: response,
                                mailSettingsTemp: Object.assign({}, response)

                            });
                        }
                    });
            } else {
                this.notificationService.create(this.state.mailSettings)
                    .then((response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            this.setState({
                                mailSettingsSaveButtonRender: false, mailSettings: response,
                                mailSettingsTemp: Object.assign({}, response)
                            });
                        }
                    });
            }
        }

    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let mailSettings = this.state.mailSettings;
        mailSettings[e.target.name] = value;
        this.setState({mailSettings: mailSettings});
    }

}

